<template>
    <div>
        <el-row class="header">
            <div class="content">
                <!-- <div class="logo-wrapper pointer" @click="go('/')"><img class="logo" src="../../assets/logo.png" alt="logo"></div> -->
                <div class="right-wrapper flex">
                    <span class="gray-text pointer" @click="loginVisibleDailog = true">我的订单</span>
                    <div class="line"></div>
                    <img class="icon pointer" src="../../assets/shop.png" alt="shop" @click="shopVisibleDialog = true">
                    <span class="gray-text pointer" @click="shopVisibleDialog = true">商家入驻</span>
                    <div class="line"></div>
                    <!-- <img class="icon pointer" src="../../assets/shopping-cart.png" alt="shop"
                        @click="loginVisibleDailog = true">
                    <span class="gray-text pointer" @click="loginVisibleDailog = true">购物车</span> -->
                    <!-- <div class="line"></div> -->
                    <div class="login flex pointer" @click="loginVisibleDailog = true">
                        <span class="gray-text">注册</span>
                        <div class="line"></div>
                        <span class="gray-text">登录</span>
                    </div>
                </div>
            </div>
        </el-row>
        <!-- 商家入驻弹窗 -->
        <store-in :visibleDialog.sync="shopVisibleDialog" v-if="shopVisibleDialog" />
        <!-- 登录弹窗 -->
        <loginDialog :visible.sync="loginVisibleDailog" />
    </div>
</template>

<script>
import storeIn from '../store-in.vue'
import loginDialog from '../login.vue'
export default {
    name: 'g-head',
    components: {
        storeIn,
        loginDialog
    },
    data() {
        return {
            shopVisibleDialog: false,
            loginVisibleDailog: false
        }
    },
    methods: {
        go(path) {
            this.$router.push(path)
        }
    }
}
</script>

<style lang="less" scoped>
.flex {
    display: flex;
}

.justify-center {
    justify-content: center;
}

.pointer {
    cursor: pointer;
}

.header {
    width: 100vw;
    height: 60px;
    box-shadow: 0px 0px 6px 0px rgba(37, 68, 118, 0.16);
    display: flex;
    align-items: center;
    margin: 0 auto;
    .content {
        width: 1260px;
        display: flex;
        align-items: center;
        position: relative;
        left: 50%;
        transform: translate(-50%);
        .logo-wrapper {
            .logo {
                width: 128px;
                height: 26px;
            }
        }

        .right-wrapper {
            position: absolute;
            min-width: 340px;
            right: -90px;
            align-items: center;

            .gray-text {
                font-size: 14px;
                font-weight: 500;
                letter-spacing: 0px;
                line-height: 20px;
                color: rgba(124, 124, 124, 1);
                text-align: left;
                vertical-align: top;
            }

            .line {
                width: 0px;
                height: 12px;
                border: 1px solid rgba(224, 224, 224, 1);
                margin-left: 9px;
                margin-right: 9px;
            }

            .icon {
                width: 19px;
                height: 17px;
                margin-right: 5px;
            }

            .login {
                min-width: 90px;
                height: 28px;
                border-radius: 10px;
                border: 1px solid rgba(224, 224, 224, 1);
                align-items: center;
                box-sizing: border-box;
                padding-left: 10px;
                padding-right: 10px;
            }
        }
    }
}

:deep(.dialog-wrapper) {
    .info {
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 21px;
        color: rgba(96, 90, 90, 1);
        text-align: left;
        vertical-align: top;
        margin-bottom: 16px;
    }

    .el-dialog__body {
        padding: 0;
        margin-top: 7px;
    }

    .el-dialog__header {
        height: 76px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;

        span {
            font-size: 18px;
            font-weight: 500;
            letter-spacing: 0.36px;
            line-height: 25px;
            color: rgba(59, 57, 72, 1);
            text-align: left;
            vertical-align: top;
        }

        button {
            display: none;
        }
    }

    .el-form {
        padding-left: 44px;
        padding-right: 44px;
        box-sizing: border-box;
    }

    .el-form-item__content {
        display: flex;
    }

    .el-form-item__label:after {
        content: '*';
        color: #F56C6C;
        margin-right: 4px;
    }

    .el-form-item__label:before {
        content: '' !important;
    }

    input {
        width: 240px;
        height: 36px;
        border-radius: 8px;
        background: rgba(247, 247, 247, 1)
    }

    .button-wrapper {
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;

        .btn {
            width: 114px;
            height: 36px;
            border-radius: 8px;
            background: rgba(244, 185, 184, 1);
            display: flex;
            align-items: center;
            justify-content: center;
            color: rgba(255, 255, 255, 1);
            line-height: 21px;
        }
    }
}
</style>